import React from 'react';
import { FormikConsumer } from 'formik';

const Debug = () => {
  const style1 = {
    margin: '3rem 0',
    borderRadius: 4,
    background: '#f6f8fa',
    boxShadow: '0 0 1px  #eee inset',
    textAlign: 'left',
  };

  const style2 = {
    fontSize: 11,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    fontWeight: 500,
    padding: '.5rem',
    background: '#555',
    color: '#fff',
    letterSpacing: '1px',
  };

  const style = {
    fontSize: '.65rem',
    padding: '.25rem .5rem',
    overflowX: 'scroll',
  };
  const isDebugMode = window.gr8piDebugMode || false;
  if (!isDebugMode) {
    return <React.Fragment />;
  }
  return (
    <div style={style1}>
      <div style={style2}>Formik State - disable with `window.gr8piDebugMode=false`</div>
      <pre style={style}>
        <FormikConsumer>
          {({
            validationSchema, validate, onSubmit, ...rest
          }) => JSON.stringify(rest, null, 2)}
        </FormikConsumer>
      </pre>
    </div>
  );
};

export default Debug;
